import styled from 'styled-components';
import AboutImage from '@/assets/images/About.svg?react';
import ConsultingImage from '@/assets/images/Consulting.svg?react';

export default function About() {
  return (
    <AboutWrapper>
      <Section>
        <StyledAboutImage />

        <TextBlock>
          <TextGroup>
            <Title>올받음</Title>
            <Subtitle>어슈런스(주)가 손해사정사를 통해 운영하는 IT 서비스</Subtitle>
            <Description>
              올받음은 보험금 전문가인 손해사정사를 통해 어려운 보험금 문제를 해결해드립니다.
            </Description>
          </TextGroup>

          <Divider>
            <InfoRow border>
              <Label>회사</Label>
              <Value>어슈런스(주)</Value>
            </InfoRow>
            <InfoRow>
              <Label>대표이사</Label>
              <Value>염선무</Value>
            </InfoRow>
            <InfoRow>
              <Label>사업번호</Label>
              <Value>117-87-02855</Value>
            </InfoRow>
            <InfoRow>
              <Label>주소</Label>
              <Value>서울시 영등포구 의사당대로 83</Value>
            </InfoRow>
            <InfoRow>
              <Label>CS 문의</Label>
              <Value>allbadeum@gmail.com</Value>
            </InfoRow>
            <InfoRow>
              <Label>제휴</Label>
              <Value
                onClick={() => (window.location.href = 'http://pf.kakao.com/_xdvBxkG')}
                style={{ textDecoration: 'underline', cursor: 'pointer', color: '#0B46DD' }}
              >
                카카오톡
              </Value>
            </InfoRow>
          </Divider>
        </TextBlock>
      </Section>
      <MessageBox>
        <MessageTitle>안녕하세요, 염선무 대표입니다.</MessageTitle>
        <MessageBody>
          저 역시 회사원으로 제휴사업 업무를 하며 제안을 하려 홈페이지를 찾았지만, 제휴 창구가
          없거나 고객 응대 부서에서 성의 없는 답장을 받는 경우가 많았습니다.
          <br />
          <br />
          저는 이런 유익한 제안들이 가볍게 다뤄지지 않기를 바랍니다. 제안은{' '}
          <strong>카카오톡</strong>을 통해 간편하게 남겨주시면, 설령 출장 등으로 다른 담당자가
          응대하더라도 <strong>모든 제안은 제가 직접 검토하고 답변드리겠습니다.</strong>
          <br />
          <br />
          감사합니다.
        </MessageBody>
      </MessageBox>
      <Section>
        <StyledConslutImage />
        <TextBlock>
          <TextGroup>
            <Title>올받음손해사정(주)</Title>
            <Subtitle>보험금 전문가인 손해사정사들이 모인 회사</Subtitle>
            <Description>
              올받음을 통해 보험금에 전문적인 정보, 상담, 손해사정사
              <br /> 서비스 등을 제공합니다.
            </Description>
          </TextGroup>

          <Divider>
            <InfoRow border>
              <Label>회사</Label>
              <Value>올받음손해사정(주)</Value>
            </InfoRow>
            <InfoRow>
              <Label>대표이사</Label>
              <Value>염선무</Value>
            </InfoRow>
            <InfoRow>
              <Label>사업번호</Label>
              <Value>291-81-03198</Value>
            </InfoRow>
            <InfoRow>
              <Label>주소</Label>
              <Value>서울시 영등포구 여의나루로 67</Value>
            </InfoRow>
            <InfoRow>
              <Label>손사상담</Label>
              <Value
                style={{ textDecoration: 'underline', cursor: 'pointer', color: '#0B46DD' }}
                onClick={() => (window.location.href = 'http://pf.kakao.com/_xdvBxkG')}
              >
                카카오톡
              </Value>
            </InfoRow>
          </Divider>
        </TextBlock>
      </Section>
    </AboutWrapper>
  );
}

const AboutWrapper = styled.div`
  display: flex;
  max-width: 850px;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: 80px;
  padding: 0 20px;
  margin-bottom: 80px;
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 26px;
  width: 100%;
`;

const StyledAboutImage = styled(AboutImage)`
  width: 100%;
  height: auto;
`;

const StyledConslutImage = styled(ConsultingImage)`
  width: 100%;
  height: auto;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  width: 100%;
`;

const TextGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
`;

const Title = styled.div`
  color: var(--color-text-text-500, #000c24);
  font-family: 'Pretendard Variable';
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.52px;
`;

const Subtitle = styled.div`
  color: var(--color-text-text-500, #000c24);
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.32px;
`;

const Description = styled.div`
  width: 100%;
  color: var(--color-text-text-500, #000c24);
  font-family: 'Pretendard Variable';
  font-size: 14px;
  font-weight: 400;
  letter-spacing: -0.28px;
  text-align: start;
`;

const Divider = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  border-top: 1px solid var(--color-text-text-500, #000c24);
`;

const InfoRow = styled.div<{ border?: boolean }>`
  display: flex;
  align-items: flex-start;
  width: 100%;
  ${(props) => (props.border ? 'border-bottom: 1px solid var(--color-text-text-50, #E6E7E9);' : '')}
`;

const Label = styled.div`
  display: flex;
  padding: 18px 18px 18px 0;
  align-items: center;
  width: 75px;
  color: var(--color-text-text-500, #000c24);
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.32px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Value = styled.div`
  display: flex;
  flex: 1;
  padding: 18px 18px 18px 0;
  align-items: center;
  color: var(--color-text-text-300, #545c6c);
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.32px;
  text-align: start;
`;

const MessageBox = styled.div`
  width: 100%;
  padding: 24px;
  background-color: #f9f9f9;
  border-left: 4px solid #0b46dd;
  border-radius: 8px;
  color: #1a1a1a;
  font-family: 'Pretendard Variable';
  line-height: 1.6;
`;

const MessageTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 12px;
`;

const MessageBody = styled.div`
  font-size: 14px;
  font-weight: 400;
  white-space: pre-line;

  strong {
    color: #0b46dd;
  }
`;
